import { Injectable } from '@angular/core';
import { AnyoEvents } from '../models/events/AnyoEvents';
import {
  NetworkUtilsService,
  URL_DICT,
} from '../../../../app-core/src/service/network-utils.service';
import { EventsListsGridRequest } from '../models/events/eventsGridRequest';
import { EventsListGridResponse } from '../models/events/eventsAdminGridResponse';
import { EventsRegistrationsGridResponse } from '../models/events/eventRegistrationGridResponse';
import { EventRegistrationGridRequest } from '../models/events/eventRegistrationGridRequest';
import { AnyoClubPass } from '../models/events/AnyoClubPasses';
import { EventsBiddingsCreateOrUpdateRequest } from '../models/events/EventsBiddingsCreateOrUpdateRequest';
import { AnyoEventsBidding } from '../models/events/AnyoEventsBidding';
import { EventsBidsListsGridRequest } from '../models/events/eventsBidsGridRequest';
import { EventsBiddingListGridResponse } from '../models/events/eventsBidsGridResponse';
import { EventsBiddingLogGridRequest } from '../models/events/eventBidsLogsGridRequest';
import { EventsBiddingLogGridResponse } from '../models/events/eventBidsLogsGridResponse';
import { AdminAcceptOrRejectBidRequest } from '../models/events/AdminAccepetOrRejectBidRequest';
import { EventsFeedbackGridRequest } from '../models/events/eventsFeedbackGridRequest';
import { EventsFeedbackGridResponse } from '../models/events/eventsFeedbackGridResponse';
import {
  AddEventRegistrationCSVRequest,
  AdminEventRegistrationResponse,
} from '../models/events/AddEventRegistrationRequest';
import {
  AddForumRegistrationCSVRequest,
  AdminForumRegistrationResponse,
} from '../models/events/AddForumRegistrationRequest';
import { CreateOrUpdateForumReqBody } from '../models/events/ForumsCreateOrUpdateRequest';
import { CreateOrUpdateEventReqBody } from '../models/events/EventsCreateOrUpdateRequest';
import { AnyoForum } from '../models/events/AnyoForums';
import { ForumsListGridRequest } from '../models/events/forumsGridRequest';
import { ForumListGridResponse } from '../models/events/forumAdminGridResponse';
import { ForumRegistrationGridRequest } from '../models/events/forumsRegistrationsGridRequest';
import { ForumsRegistrationsGridResponse } from '../models/events/forumRegistrationsGridResponse';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  constructor(private api: NetworkUtilsService) { }

  listEvents(gridRequest: EventsListsGridRequest) {
    return this.api.post<EventsListGridResponse>(
      URL_DICT.eventsGridUrl,
      gridRequest,
    );
  }

  listEventRegistration(gridRequest: EventRegistrationGridRequest) {
    return this.api.post<EventsRegistrationsGridResponse>(
      URL_DICT.eventsRegistrationGridUrl,
      gridRequest,
    );
  }

  getEvents(id: string) {
    return this.api.get<AnyoEvents>(URL_DICT.eventsGetUrl + `${id}`);
  }

  getAllClubPasses() {
    return this.api.get<AnyoClubPass[]>(URL_DICT.getClubPass);
  }

  addOrUpdateEventBidding(req: EventsBiddingsCreateOrUpdateRequest) {
    return this.api.post(URL_DICT.adminAddOrUpdateEventsBidding, req);
  }
  getEventBidding(id: string) {
    return this.api.get<AnyoEventsBidding>(URL_DICT.adminGetEventsBidding + id);
  }

  getEventBidsListGrid(gridRequest: EventsBidsListsGridRequest) {
    return this.api.post<EventsBiddingListGridResponse>(
      URL_DICT.adminEventsBidsGridUrl,
      gridRequest,
    );
  }
  getEventBidsLogGrid(gridRequest: EventsBiddingLogGridRequest) {
    return this.api.post<EventsBiddingLogGridResponse>(
      URL_DICT.adminEventsBidsLogGridUrl,
      gridRequest,
    );
  }
  acceptOrRejectBid(req: AdminAcceptOrRejectBidRequest) {
    return this.api.post(URL_DICT.adminAcceptOrRejectBid, req);
  }

  getEventsFeedbackGrid(req: EventsFeedbackGridRequest) {
    return this.api.post<EventsFeedbackGridResponse>(
      URL_DICT.adminAnyoEventsFeedbackUrl,
      req,
    );
  }
  addEventRegistration(req: AddEventRegistrationCSVRequest) {
    return this.api.post<AdminEventRegistrationResponse>(
      URL_DICT.addEventRegistrationUrl,
      req,
    );
  }

  addOrUpdateEvent(req: CreateOrUpdateEventReqBody) {
    return this.api.post(URL_DICT.adminCreateOrUpdateEvent, req);
  }

  addOrUpdateForum(req: CreateOrUpdateForumReqBody) {
    return this.api.post(URL_DICT.adminCreateOrUpdateForum, req)
  }

  getForum(id: string) {
    return this.api.get<AnyoForum>(URL_DICT.forumGetUrl + `${id}`);
  }

  listForums(gridRequest: ForumsListGridRequest) {
    return this.api.post<ForumListGridResponse>(URL_DICT.forumGridUrl, gridRequest)
  }

  getForumRegistrations(gridRequest: ForumRegistrationGridRequest) {
    return this.api.post<ForumsRegistrationsGridResponse>(URL_DICT.forumRegistrationsGridUrl, gridRequest)
  }

  addForumRegistration(req: AddForumRegistrationCSVRequest) {
    return this.api.post<AdminForumRegistrationResponse>(
      URL_DICT.addForumRegistrationUrl,
      req,
    );
  }
}
